import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import {
  formatCurrency,
  getTrimmedString,
} from 'components/project/ClerkScreen/shared/utils/common';
import {
  Media,
  ItemName,
  PublicComments,
} from 'components/project/ClerkScreen';

import { OnlineIndicator } from '../Chat/OnlineIndicator/index';
import {
  CenteredTrack,
  Container,
  Label,
  PrivateCommentsContainer,
  ProxyBid,
  PublicCommentsContainer,
  Track,
  TrackKey,
  TrackValue,
} from './Styles';

const ItemDetails = () => {
  const {
    BidStore: { auctionProduct, auction },
    AuctionStore: { laneClientList },
  } = useStores();

  const getSellerMemberName = (accountName) => {
    const sellerListener = laneClientList?.filter((seller) => seller.accountName === accountName);
    return (sellerListener?.length > 0) ? sellerListener[0].memberName : '';
  }
  const getProductDetail = (key) =>
    auctionProduct && auctionProduct[key]
      ? getTrimmedString(auctionProduct[key])
      : '-';

  const getProductDetailCurrencyValue = (key) => {
    const value = getProductDetail(key);
    if (value !== '-') {
      return `$${formatCurrency(value)}`;
    }
    return value;
  };
  const reserve = getProductDetailCurrencyValue('reserve');
  const reserveType = getProductDetail('reserveType');

  const getFormattedReserve = () => {
    const reserveNumber = Number(reserve.replace(/\D/g, ''));
    if (reserveNumber === 0 && reserveType !== 'No Reserve') return '-';
    if (reserveNumber === 0 && reserveType === 'No Reserve')
      return 'No Reserve';
    if (reserveNumber > 0 && reserveType !== '-')
      return `${reserve} (${reserveType})`;
    return reserve;
  };

  return (
    <Container>
      <CenteredTrack>
        {/* <Label>Item</Label> */}
        <ItemName />
      </CenteredTrack>
      {auction.sellerAccount && (
        <Track>
          <TrackKey>Seller:</TrackKey>
          <TrackValue>
            <div>
              <OnlineIndicator
                user={`${getSellerMemberName(auction.sellerAccountName)}`}
                includeUser={false}
              />
              {auction.sellerAccountName}
            </div>
            <div>{auction.sellerAccount}</div>
          </TrackValue>
        </Track>
      )}
      <Track>
        <TrackKey>Book Value:</TrackKey>
        <TrackValue>
          ${auctionProduct && formatCurrency(auctionProduct.bookValue)}
        </TrackValue>
      </Track>
      <Track>
        <TrackKey>Reserve:</TrackKey>
        <TrackValue>
          {getFormattedReserve()}
          {/* $
          {auctionProduct && formatCurrency(auctionProduct.reserve)} */}
        </TrackValue>
      </Track>
      <CenteredTrack>
        <Label>Proxy Bids</Label>
        {auctionProduct?.top2ProxyBids?.length ? (
          auctionProduct.top2ProxyBids.map((item, index) => (
            <ProxyBid key={index} inPlay={item.proxyBid < auction.currentBid}>
              ${formatCurrency(item.proxyBid)} - {item.authorizedMember}
            </ProxyBid>
          ))
        ) : (
          <div>No bids</div>
        )}
      </CenteredTrack>
      <CenteredTrack>
        <Media />
      </CenteredTrack>
      <PublicCommentsContainer>
        <Label>Public Comments:</Label>
        <div>
          <PublicComments noCommentsText="No comments" />
        </div>
      </PublicCommentsContainer>
      <PrivateCommentsContainer>
        <Label>Private Notes:</Label>
        <div>
          {auctionProduct && auctionProduct.privateComments
            ? auctionProduct.privateComments
            : 'No comments'}
        </div>
      </PrivateCommentsContainer>
    </Container>
  );
};

export default observer(ItemDetails);
